module.exports = __webpack_public_path__ + "static/img/3-6.4.5.9c4aa37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/3-6.4.5.png
// module id = RD1T
// module chunks = 0